<script>
import nonEmptyStringValidator from 'foundation/js/inputValidators/nonEmptyStringValidator';
import options from './CreateFrivilligJob.options'
export default options
</script>

<template>
  <article class="kb-create-frivillig-job">
    <section class="kb-stafet-flow-title">

      <h1 class="kb-stafet-flow-title__title">{{ isEditContext ? getLabel('editTitle') : getLabel('createTitle') }}</h1>
      <div class="kb-stafet-flow-title__breaker">
        <svg viewBox="0 0 81 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z" />
        </svg>
      </div>

      <div class="kb-stafet-flow-title__description">
        <p class="kb-stafet-flow-title__description-text">{{ getLabel('jobDescription')  }}</p>
      </div>
    </section>

    <section class="kb-stafet-step kb-optimizely-forms kb-stafet-donation-flow__step">
      <h2 class="kb-stafet-step__step-section-title">{{ getLabel('descriptionTitle') }}</h2>

      <div class="kb-stafet-step__input-wrapper">
        <FormInputTextField
            isRequired
            type="text"
            v-model="jobData.jobTitle"
            fieldName="jobTitle"
            :label="getLabel('jobTitleLabel')"
            :isValidationError="displayError && !nonEmptyStringValidator(jobData.jobTitle)"
            :errorMessageLabel="getLabel('requiredFieldMissingError')"/>

          <div class="Form__Element" :class="{ValidationRequired: true}">
            <label class="Form__Element__Caption">{{ getLabel("aboutJobLabel") }}</label>
            <editor api-key="no-api-key" :init='{
                plugins: "emoticons autoresize lists autolink",
                toolbar: "emoticons bold italic underline bullist numlist",
                toolbar_location: "bottom",
                menubar: false,
                statusbar: false,
                license_key: "gpl"
              }'
              v-model="jobData.aboutJob"
            ></editor>
            <p v-if="displayError && !nonEmptyStringValidator(jobData.aboutJob)" class="kb-forms Form__Element__ValidationError">{{ getLabel('requiredFieldMissingError') }}</p>
          </div>


        <div class="Form__Element" :class="{ValidationRequired: true}">
          <label class="Form__Element__Caption">{{ getLabel("offerDescriptionLabel") }}</label>
          <editor 
            api-key="no-api-key"
            :init='{
              plugins: "emoticons autoresize lists autolink",
              toolbar: "emoticons bold italic underline bullist numlist",
              toolbar_location: "bottom",
              menubar: false,
              statusbar: false,
              license_key: "gpl"
            }'
            v-model="jobData.offerDescription"
          ></editor>
          <p v-if="displayError && !nonEmptyStringValidator(jobData.offerDescription)" class="kb-forms Form__Element__ValidationError">{{ getLabel('requiredFieldMissingError') }}</p>
        </div>

        <div class="Form__Element" :class="{ValidationRequired: true}">
          <label class="Form__Element__Caption">{{ getLabel("expectationDescription") }}</label>
          <editor api-key="no-api-key" :init='{
              plugins: "emoticons autoresize lists autolink",
              toolbar: "emoticons bold italic underline bullist numlist",
              toolbar_location: "bottom",
              menubar: false,
              statusbar: false,
              license_key: "gpl"
            }'
            v-model="jobData.expectationDescription"
          ></editor>
          <p v-if="displayError && !nonEmptyStringValidator(jobData.expectationDescription)" class="kb-forms Form__Element__ValidationError">{{ getLabel('requiredFieldMissingError') }}</p>
        </div>
      </div>

      <hr class="kb-stafet-step__breaker-line kb-stafet-step__breaker-line--smaller" />

      <h2 class="kb-stafet-step__step-section-title">{{ getLabel('jobInfoTitle') }}</h2>

      <div class="kb-stafet-step__input-wrapper">
        <FormInputTextField
          type="text"
          v-model="jobData.placeName"
          fieldName="placeName"
          :label="getLabel('placeNameLabel')"
          :placeholder="getLabel('placeNamePlaceholder')" />

        <FormCheckbox fieldName="isCountrywide"
          :modelValue="jobData.isCountrywide.toString()"
          v-model="jobData.isCountrywide"
          :label="getLabel('isCountrywideLabel')"
          :onChangeCallback="(e) => setIsCountryWide(e)" />

        <FormAddressField
          v-if="!jobData.isCountrywide"
          v-model:address-line-value="jobData.address"
          v-model:zip-code-value="jobData.postalCode"
          v-model:city-value="jobData.city"
          :addressLabel="getLabel('addressLabel')"
          :zipCodeLabel="getLabel('zipCodeLabel')"
          :cityLabel="getLabel('cityLabel')"
          :addressPlaceholder="getLabel('addressPlaceholderLabel')"
          :zipCodePlaceholder="getLabel('zipCodePlaceholderLabel')"
          :cityPlaceholder="getLabel('cityPlaceholderLabel')"
          :isValidationError="displayError && !addressValidator(jobData.address, jobData.postalCode, jobData.city, jobData.isCountrywide)"
          :errorMessageLabel="getLabel('addressErrorLabel')" />

        <FormCheckbox
          fieldName="hasSpecificDate"
          :modelValue="hasSpecificDate.toString()"
          v-model="hasSpecificDate"
          :label="getLabel('hasSpecificDateLabel')"
          :onChangeCallback="(e) => setSpecificDateCheckbox(e)" />

        <FormCheckbox
          v-if="hasSpecificDate"
          fieldName="hasSpecificTime"
          :modelValue="jobData.hasSpecificTime.toString()"
          v-model="jobData.hasSpecificTime"
          :label="getLabel('hasSpecificTimeLabel')"
          :onChangeCallback="(e) => setSpecificTimeCheckbox(e)" />

        <div class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half"
          v-if="hasSpecificDate || jobData.hasSpecificTime">
          <FormInputTextField
            v-if="hasSpecificDate"
            fieldName="startDate"
            type="date"
            :modelValue="startDate"
            v-model="startDate"
            :label="getLabel('startDateLabel')"
          />

          <FormInputTextField
            v-if="jobData.hasSpecificTime"
            fieldName="startTime"
            type="time"
            :modelValue="startTime"
            v-model="startTime"
            :label="getLabel('startTimeLabel')"
          />
        </div>

        
        <div class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half"
          v-if="jobData.hasSpecificTime || hasSpecificDate">
          <FormInputTextField
            v-if="hasSpecificDate"
            fieldName="endDate"
            type="date"
            :modelValue="endDate"
            v-model="endDate"
            :label="getLabel('endDateLabel')"
            :isValidationError="displayError && !isPeriodValid"
            :errorMessageLabel="getLabel('periodError')"
          />

          <FormInputTextField
            v-if="jobData.hasSpecificTime"
            fieldName="endTime"
            type="time"
            :modelValue="endTime"
            v-model="endTime"
            :label="getLabel('endTimeLabel')"
          />
        </div>

        <FormInputTextField
              isRequired
              fieldName="timeConsumption"
              v-model="jobData.timeConsumption"
              :label="getLabel('timeConsumptionLabel')"
              :placeholder="getLabel('timeConsumptionPlaceholder')"
              :isValidationError="displayError && !nonEmptyStringValidator(jobData.timeConsumption)"
              :errorMessageLabel="getLabel('requiredFieldMissingError')"              
            />

        <h3 class="kb-stafet-step__step-subsection-title">{{ getLabel('contactPersonTitle') }}</h3>

        <FormCheckbox 
          v-if="!isEditContext"
          fieldName="isSelfContactPerson"
          :modelValue="jobData.isSelfContactPerson.toString()"
          v-model="jobData.isSelfContactPerson" 
          :label="getLabel('isSelfContactPersonLabel')"
          :onChangeCallback="(e) => jobData.isSelfContactPerson = e.target.checked" />

        <div v-if="isEditContext || !jobData.isSelfContactPerson">
          <FormInputTextField 
            fieldName="contactPersonName"
            type="text"
            :modelValue="jobData.contactPersonName"
            :isRequired="true"
            v-model="jobData.contactPersonName"
            :isValidationError="displayError && !nonEmptyStringValidator(jobData.contactPersonName)"
            :label="getLabel('contactPersonNameLabel')"
            :errorMessageLabel="getLabel('contactPersonNameErrorLabel')"/>

          <FormInputTextField
            fieldName="contactPersonEmail"
            type="email"
            :modelValue="jobData.contactPersonEmail"
            :isRequired="true"
            v-model="jobData.contactPersonEmail"
            :label="getLabel('contactPersonEmailLabel')"
            :isValidationError="displayError && !emailValidator(jobData.contactPersonEmail)"
            :errorMessageLabel="getLabel('contactPersonEmailErrorLabel')" />

          <FormInputTextField 
            fieldName="contactPersonPhone"
            type="phone"
            :modelValue="jobData.contactPersonPhone"
            v-model="jobData.contactPersonPhone"
            :label="getLabel('contactPersonPhoneLabel')"
            :isValidationError="displayError && (jobData.contactPersonPhone.length === 0 || !phoneValidator(jobData.contactPersonPhone))"
            :errorMessageLabel="getLabel('contactPersonPhoneErrorLabel')" />
        </div>
      </div>

      <hr class="kb-stafet-step__breaker-line kb-stafet-step__breaker-line--smaller" />

      <h2 class="kb-stafet-step__step-section-title">{{ getLabel('aboutTitle') }}</h2>
      <div class="kb-stafet-step__input-wrapper">

        <h3 class="kb-stafet-step__step-subsection-title">{{ getLabel("imageSubsectionTitle") }}</h3>
        <label class="kb-stafet-step__texts-description">{{ getLabel("imageSubsectionDescription") }}</label>

        <AttachmentsEditor
          :files="images"
          acceptedFileTypes=".gif, .jpeg, .jpg, .bmp, .png"
          :maxAttachments=1
          @update:filesToAdd="(e) => setImage(e)"
        />

        <h3 class="kb-stafet-step__step-subsection-title">{{ getLabel('subjectsTitle') }}</h3>

        <fieldset class="kb-edit-frivillig-profile__fieldset">
          <div class="kb-edit-frivillig-profile__two-column">
            <div class="kb-stafet-step__input-wrapper" v-for="subject, index in subjects" :key="index">
              <FormCheckbox 
                :fieldName="subject.name"
                :modelValue="subject.isSelected.toString()"
                v-model="subject.isSelected"
                :label="subject.name"
                :onChangeCallback="(e) => setSubject(subject.value, e.target.checked)"
              />
            </div>  
          </div>
        </fieldset>
        
        <FormInputTextField
              fieldName="expirationDate"
              type="date"
              :modelValue="expirationDate"
              v-model="expirationDate"
              :label="getLabel('expirationDateLabel')"
              :isRequired="true"
              :isValidationError="displayError && !isFutureDate(expirationDate)"
              :errorMessageLabel="getLabel('expirationDateErrorLabel')"
            />
      </div>

      <template v-if="isSubmitting">
        <div class="kb-spinner-overlay">
          <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky">
          </div>
        </div>
      </template>

      <nav class="kb-stafet-flow-actions">
        <div class="kb-stafet-flow-actions__buttons-right-wrapper">
          <button class="kb-button kb-button--full-color-spot kb-button--full-color-spot" v-on:click="submitCreateJob"
            :class="{
              'kb-button--disabled': isSubmitting
            }">
            {{ getLabel('submitButtonLabel') }}
          </button>
        </div>
      </nav>
    </section>
  </article>
</template>
